import { z } from 'zod';

export const EXTERNAL_SYSTEMS = ['salesforce', 'clay', 'slack', 'gong', 'google', 'render'] as const;

export const ExternalSystemSchema = z.enum(EXTERNAL_SYSTEMS);
export type ExternalSystem = z.infer<typeof ExternalSystemSchema>;

export const LeaseModeSchema = z.enum(['sandbox', 'live']);
export type LeaseMode = z.infer<typeof LeaseModeSchema>;

export const LEASE_MINUTES_MIN = 1;
export const LEASE_MINUTES_MAX = 120;
export const LEASE_MINUTES_DEFAULT = 30;

export const EXTERNAL_SYSTEM_META: Record<
  ExternalSystem,
  { label: string; blastRadius: string; chokepoints: readonly string[] }
> = {
  salesforce: {
    label: 'Salesforce',
    blastRadius: 'Creates, updates and deletes real records in the Salesforce org.',
    chokepoints: ['src/services/salesforce/write-gate.ts'],
  },
  clay: {
    label: 'Clay',
    blastRadius: 'Starts real Clay routine runs and posts to Clay webhooks.',
    chokepoints: ['src/services/clay/routine-run-transport.ts', 'src/services/clay/webhook-post.ts'],
  },
  slack: {
    label: 'Slack',
    blastRadius: 'Posts real messages and changes real channels in Slack.',
    chokepoints: ['src/slack/client.ts'],
  },
  gong: {
    label: 'Gong',
    blastRadius: 'Assigns real prospects to Gong flows.',
    chokepoints: ['src/services/gong/gong-client.ts'],
  },
  google: {
    label: 'Google',
    blastRadius: 'Sends real email and creates real Sheets and Calendar watches.',
    chokepoints: ['mini-apps/_shared/google.ts'],
  },
  render: {
    label: 'Render',
    blastRadius: 'Changes real Render services with an unscoped API key.',
    chokepoints: ['src/services/render-api.ts'],
  },
};
